import React from 'react'
import FieldConfig from "../../../proto/field-config";
import {FIELDS} from "../../../fields.const";
import FieldProto from "../../../proto/field-proto";
import FieldDateRangeRelative_FormElementView from "./render/form-element-view";


// i.e. {start: -7, end: 7) -> nedlelu nazda nedelu vpered
export type DateRangeRelativeValue = {
    start  : number|null,
    end    : number|null
}

export default class FieldDateRangeRelative extends FieldProto {


    constructor(config:FieldConfig) {

        config.type = FIELDS.DATE_RANGE_RELATIVE

        super(config);

        this.typeLabel          = "Date range";
        this.icon               = 'i5-calendar';
        // this.typeGroup          = GROUP_DATE_TIME
        // this.typeDescription    = 'Start-End daterange field'
        // this.clearButton        = _.get(config,'clearButton',true);

        this.components = _.assign({}, this.components, {
            // PopoverMenu             : FieldDateRange_Popover,
            // FormValueNotEmpty       : FieldDateRange_FormValueNotEmpty,
            // ValueIcon               : <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        })

        _.assign(this.renderComponents, {
            // view                    : FieldDateRange_View,
            // inlineEditable          : FieldDateRange_InlineEditable,

            formElementView         : FieldDateRangeRelative_FormElementView

        })
    }

    // // we need to convert it to daterange
    // getViewValue(model:any) {
    //     let value = _.get(model, this.fieldId, null)
    //
    //     if (value) {
    //         value = convertToMomentRangeFromValue(value)
    //     }
    //
    //     return value
    // }
    //
    // getDisplayValue(value:any) {
    //     if (!value) return false
    //
    //     const daterange = convertToMomentRangeFromValue(value)
    //
    //     return "{0} - {1}".f(formatDate(daterange.start), formatDate(daterange.end))
    // }

}
